@if (loading()) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
}
<mat-toolbar>

  <span class="spacer"></span>

  <a mat-flat-button
     routerLink="../../screening"
     aria-label="Open Settings dialog"
  >
    <mat-icon>tune</mat-icon>
    <span>Back to Screening</span>
  </a>
</mat-toolbar>

@if (papers().length > 0) {
  @if (settings(); as settings) {
    <app-research-prisma-flow [papers]="papers()"
                              [queries]="settings.researchDBSettings || []"></app-research-prisma-flow>
  } @else {
    <p>Loading queries ...</p>
  }
  <!--
  <mat-tab label="Screening Flow (Paper)">
    <h2>Screening Result (Flow)</h2>
    <div class="echarts" echarts [options]="chartOption"></div>
  </mat-tab>!-->

} @else {
  <div class="no-papers">
    <p>No papers included, please start online search</p>
  </div>
}

